import { gql } from '@apollo/client';

export const EDIT_URL = gql`
  mutation editUrl($fileId: Float!, $title: String!, $newUrl: String!, $user: String!) {
    editUrl(fileId: $fileId, title: $title, newUrl: $newUrl, user: $user)
  }
`;